import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { withTranslation } from 'react-i18next';
import ValidatedTextField from '../ValidatedTextField';
import states from '../../constants/stateSelectOptions';

import ValidatedSelectField from '../ValidatedSelectField';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

const PersonalInfo = ({
	formData,
	errors,
	handleInputChange,
	handleInputBlur
}) => {
	return (
		<Paper
			sx={{
				padding: '15px',
				backgroundColor: (theme) => theme.palette.common.white
			}}
		>
			<Stack
				direction={{ xs: 'column', sm: 'row' }}
				justifyContent='space-between'
				alignItems={{ xs: 'flex-start', sm: 'center' }}
				mb={2}
			>
				<Stack direction='row' alignItems='center' spacing={1}>
					<PersonOutlineIcon />
					<Typography
						variant='h6'
						component='h2'
						sx={{ textTransform: 'uppercase' }}
					>
						{t('personalInfo:headerText')}
					</Typography>
				</Stack>
				<Stack width={{ xs: '100%', sm: 'auto' }}>
					<Typography
						color={(theme) => theme.palette.error.main}
						fontSize='0.8em'
						textAlign='right'
						alignSelf={{ xs: 'stretch', sm: 'center' }}
					>
						{t('home:allFieldsRequired')}
					</Typography>
				</Stack>
			</Stack>
			<Stack spacing={3}>
				<Stack spacing={2} direction='row'>
					<ValidatedTextField
						name='firstName'
						label={t('personalInfo:firstName')}
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						required
						errors={errors}
					/>
					<ValidatedTextField
						name='lastName'
						label={t('personalInfo:lastName')}
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						required
						errors={errors}
					/>
				</Stack>

				<ValidatedTextField
					name='address1'
					label={t('personalInfo:address1')}
					formData={formData}
					handleInputChange={handleInputChange}
					handleInputBlur={handleInputBlur}
					required
					errors={errors}
				/>
				<ValidatedTextField
					name='address2'
					label={t('personalInfo:address2')}
					formData={formData}
					handleInputChange={handleInputChange}
					handleInputBlur={handleInputBlur}
					errors={{}}
				/>

				<Stack spacing={2} direction='row'>
					<ValidatedTextField
						name='city'
						label={t('personalInfo:city')}
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						required
						errors={errors}
					/>
					<ValidatedSelectField
						name='state'
						label={t('personalInfo:state')}
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						options={states}
						required
						errors={errors}
					/>
					<ValidatedTextField
						name='zipCode'
						label={t('personalInfo:zipCode')}
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						required
						errors={errors}
					/>
				</Stack>

				<Stack spacing={2} direction='row'>
					<ValidatedTextField
						name='email'
						label={t('personalInfo:email')}
						type='email'
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						required
						errors={errors}
					/>
					<ValidatedTextField
						name='phone'
						label={t('personalInfo:phone')}
						type='tel'
						formData={formData}
						handleInputChange={handleInputChange}
						handleInputBlur={handleInputBlur}
						required
						errors={errors}
					/>
				</Stack>
			</Stack>
		</Paper>
	);
};

PersonalInfo.propTypes = {
	t: PropTypes.func,
	formData: PropTypes.object,
	errors: PropTypes.object,
	handleInputChange: PropTypes.func,
	handleInputBlur: PropTypes.func
};

export default withTranslation('PersonalInfo')(PersonalInfo);
